/** Tekst iz podataka (naziv firme, napomena...) za umetanje u HTML štampe: bez ovoga bi "<" u tekstu pokvario tabelu. */
export const escapeHtml = (value) =>
  String(value === null || value === undefined ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export default escapeHtml;
